export interface UmpirePublicationOptions {
  readonly is_draft: boolean;

  readonly publication_time: string | null;

  readonly published_at: string | null;
}
